// componente per la visualizzazione del footer; non contiene metodi particolari, ma permette di esportare la classe "FooterComponent"
// con la sua pagina HTML ed il suo scss

import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-footer2',
    templateUrl: './footer2.component.html',
    styleUrls: ['./footer2.component.scss']
})
export class Footer2Component implements OnInit {

    constructor(
    ) {
    }

    ngOnInit() {
    }
}
